<template>
  <section class="albums">
    <TheArticleList
      :articles="albums.data"
      linkPath="albums"
      displayType="album"
    >
      <TheListTitle :listTitle="articleTitle" prefix="album" />
    </TheArticleList>
    <TheListPagination
      category="albums"
      :pages="albums"
      @update:getUpdatedArticles="$store.dispatch('getUpdatedArticles', $event)"
    />
  </section>
</template>

<script>
import { getArticleString } from "@/config/articleString";
// import { lazyloading } from '@/utils/lazyloading';

import TheListTitle from "@/components/list/TheListTitle";
import TheArticleList from "@/components/list/TheArticleList";
import TheListPagination from "@/components/list/TheListPagination";

export default {
  name: "TheAlbums",
  metaInfo() {
    return {
      title: "圖鑑集",
      meta: [
        {
          vmid: "og:url",
          property: "og:url",
          content: this.productionWholeReference,
        },
        {
          vmid: "og:title",
          property: "og:title",
          content: "臺南宗教藝術-圖鑑集",
        },
        {
          vmid: "og:description",
          property: "og:description",
          content: "臺南宗教藝術的美圖都在這裡。",
        },
      ],
    };
  },
  data() {
    return {};
  },
  computed: {
    albums() {
      return this.$store.getters.albums;
    },
    productionWholeReference() {
      return `${this.$store.getters.productionHostname}${window.location.pathname}${window.location.search}`;
    },
    articleTitle() {
      return getArticleString("theme", "headline");
    },
  },
  async mounted() {
    await this.getAlbums();
    // await lazyloading();
  },
  methods: {
    async getAlbums() {
      // 載入旅遊列表頁，以 API 資料作為初始值
      try {
        await this.$store.dispatch("getAlbums");
      } catch (e) {
        console.error(e);
      }
    },
  },
  components: {
    TheListTitle,
    TheArticleList,
    TheListPagination,
  },
};
</script>

<style lang="scss" scoped></style>
